import axios from '../api';

// Auth Service
const authService = {
  // Enable 2FA - Get QR code
  enable2FA: async () => {
    const response = await axios.post('/api/auth/enable-2fa');
    return response.data;
  },

  // Confirm 2FA - Verify first code and activate
  confirm2FA: async (token: string) => {
    const response = await axios.post('/api/auth/confirm-2fa', { token });
    return response.data;
  },

  // Disable 2FA
  disable2FA: async () => {
    const response = await axios.post('/api/auth/disable-2fa');
    return response.data;
  },

  // Verify 2FA code during login
  verify2FA: async (userId: string, token: string) => {
    const response = await axios.post('/api/auth/verify-2fa', {
      userId,
      token,
    });
    return response.data;
  },

  // Get current user
  getMe: async () => {
    const response = await axios.get('/api/auth/me');
    return response.data.user;
  },
};

export default authService;
